import firebase from "firebase/app";
import "firebase/messaging";
import { loginUser } from "store/actions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
};

// Initialize Firebase (only once)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const isMessagingSupported = firebase.messaging.isSupported?.();
const VAPID_KEY = process.env.REACT_APP_VAPID_KEY;
let messaging = null;

console.log("isMessagingSupported:", isMessagingSupported);

if (isMessagingSupported) {
  try {
    messaging = firebase.messaging();
    console.log("messaging1:", messaging);
  } catch (err) {
    console.error("Firebase messaging initialization error:", err);
  }
} else {
  console.warn("Firebase messaging is not supported on this browser.");
}

/**
 * Get FCM token and store in localStorage if changed.
 * @param {Function} setTokenFound - State setter to indicate token availability.
 * @returns {Promise<string>} - The token or empty string.
 */

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    console.log("Notification permission:", permission);
    return permission;
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    return 'denied';
  }
};

export const getToken = async (setTokenFound = () => {}) => {
  if (!messaging || !VAPID_KEY) {
    console.warn("FCM token fetch skipped: messaging not initialized or VAPID key missing.");
    setTokenFound(false);
    return "";
  }

  // Check current permission status
  const currentPermission = Notification.permission;
  
  if (currentPermission === 'denied') {
    console.warn("Notification permission is denied. Cannot get FCM token.");
    setTokenFound(false);
    return "";
  }

  // Request permission if not already granted
  if (currentPermission !== 'granted') {
    const permission = await requestNotificationPermission();
    if (permission !== 'granted') {
      console.warn("Notification permission not granted. Cannot get FCM token.");
      setTokenFound(false);
      return "";
    }
  }

    const userData = JSON.parse(localStorage.getItem("authUser"))
    console.log("userData in notification", userData)

  console.log("messaging:", messaging);
  console.log("VAPID_KEY:", VAPID_KEY);

  try {
    const currentToken = await messaging.getToken({ vapidKey: VAPID_KEY });
    console.log("FCM token retrieved:", currentToken);
    
    if (currentToken) {
      setTokenFound(true);
      const storedToken = localStorage.getItem("notificationToken");
      if (storedToken !== currentToken) {
        console.info("FCM token updated.");
        localStorage.setItem("notificationToken", currentToken);
      }
      return currentToken;
    } else {
      console.warn("No FCM token retrieved. Permission might be blocked or VAPID key invalid.");
      setTokenFound(false);
      return "";
    }
  } catch (error) {
    console.error("Error while getting FCM token:", error);
    setTokenFound(false);
    return "";
  }
};

/**
 * Listener for foreground messages.
 * @returns {Promise<Object>} - Promise that resolves with the message payload.
 */
export const onMessageListener = () =>
  new Promise(resolve => {
    if (!messaging) {
      console.warn("Cannot listen to messages: messaging not initialized.");
      return;
    }
    messaging.onMessage(payload => {
      console.log("Foreground message received:", payload);
      resolve(payload);
    });
  });